/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: network-edit-view-component
 *
 * Created by rwilliams on 7/25/17.
 */
'use strict';
function NetworkEditViewController($location, NetworkViewService, PermissionsService, SidebarService) {
    var self = this;

    self.getBreadcrumbName = function () {
        return NetworkViewService.breadcrumbName;
    };

    self.setActiveTab = function (tab) {
        $location.search('view', tab);
        if (self.currentTab !== tab) {
            self.currentTab = tab;
        }
    };

    self.$onInit = function () {
        SidebarService.editService = NetworkViewService;
        this.isAdmin = PermissionsService.isAdmin();
        self.permissionViewStates = NetworkViewService.permissionViewStates;
        NetworkViewService.getViewPermissions().then(function (permissions) {
            self.permissions = permissions;

            //If there are write permissions for both preroll and postroll then there are
            //also permissions for break pre/postroll
            self.setActiveTab($location.search().view || 'properties');
        });
    };

    self.$onDestroy = function () {
        $location.search('view', null);
    };
}

angular.module('prism-ui.network').component('networkEditView', {
    templateUrl: 'meta/network/editor/network-edit-view-template.html',
    controller: NetworkEditViewController,
    bindings: {
    }
});
